export const setupFractionCounter = (emblaApi, counterNode) => {
    const updateCounter = () => {
        const selectedSnap = emblaApi.selectedScrollSnap();
        const snapCount = emblaApi.scrollSnapList().length;
        counterNode.innerHTML = `<span class="embla__fraction__current">${selectedSnap + 1}</span> / <span class="embla__fraction__total">${snapCount}</span>`;
    };

    emblaApi.on('select', updateCounter);
    emblaApi.on('reInit', updateCounter);
    updateCounter(); // Roda na inicialização
};